// extracted by mini-css-extract-plugin
module.exports = {"root":"_dd48f1","container-xs":"_bd0ac0","container-sm":"_aca586","container-md":"_dc965a","container-lg":"_1974d3","container-xl":"_774f27","fixedWidth":"_47476d"};